/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect, useState, useRef } from "react";
import Grid from "@mui/material/Grid";
//componenets
import Button from "../../../component/button";
import Input from "../../../component/inputpm";
import InputPhone from "../../../component/inputPhone";
import { withTranslation } from "react-i18next";
import stateCode from "../../../helper/stateCode";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { getStatesList } from "../../../helper/getStateList";
import Loader from "../../../component/loader";
import actionTypes from "../../../store/actions";
import { connect } from "react-redux";
import { Divider } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";

const ContactDetails = (props) => {
  const t = props.t;
  const [loading, setLoading] = useState(false);
  const hiddenFileInput = useRef(null);
  const uploadButtonClicked = (event) => {
    hiddenFileInput.current.click();
  };
  useEffect(() => {
    if (props.providerData.contacts && props.providerData.contacts.length > 0) {
      if (
        props.providerData.contacts[0].address &&
        props.providerData.contacts[0].address.country
      ) {
        getStates(props.providerData.contacts[0].address.country);
      }
    }
  }, []);

  const [statesList, setStatesList] = useState([]);
  const getStates = (country) => {
    setLoading(true);
    getStatesList(country)
      .then((res) => {
        setStatesList(res);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(props.t("FAILED_TO_LOAD_STATES"), false);
        }
      });
  };
  const [logoPreview, setLogoPreview] = useState(props.tenantData.logo);
  const [themeColor, setThemeColor] = useState(props.tenantData.color);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.replace(
          /^data:image\/(jpeg|jpg|png|svg);base64,/,
          "",
        );
        // base64String = base64String.replace(/^data:image\/(jpeg|jpg|png|svg);base64,/, '');
        setLogoPreview(base64String);
        props.setLogoPreview(base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  //const {error} = props.error;
  return (
    <Grid container spacing={3}>
      {!props.isUpdate && (
        <>
          <Grid
            item
            size={{
              xs: 12,
            }}
          >
            <h3>
              {t("BASIC_DETAILS_FOR")}&nbsp;
              {props.providerRole === "SERVICE_PROVIDER"
                ? t("SERVICE_PROVIDER")
                : props.providerRole === "SOLUTION_PROVIDER"
                  ? t("SOLUTION_PROVIDER")
                  : props.providerRole === "SALES_CHNL_PROVIDER"
                    ? t("SALES_CHANNEL_PROVIDER")
                    : ""}
            </h3>
          </Grid>
        </>
      )}
      <Grid
        item
        size={{
          xs: 12,
        }}
      >
        <h3 className={"no-margin"}>{t("PROFILE_DETAILS")}</h3>
      </Grid>
      <Grid
        item
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Input
          error={!!props.error.firstName}
          helperText={props.error.firstName}
          name={"firstName"}
          size={"small"}
          variant={"outlined"}
          value={props.loggedInUserData.contact.firstName}
          placeholder={t("FIRST_NAME") + "*"}
          onChange={(event) => {
            props.onChange(event);
            props.updateError("firstName");
          }}
        />
      </Grid>
      <Grid
        item
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Input
          name={"lastName"}
          size={"small"}
          variant={"outlined"}
          value={props.loggedInUserData.contact.lastName}
          placeholder={t("LAST_NAME")}
          onChange={(event) => {
            props.onChange(event);
          }}
        />
      </Grid>
      <Grid
        item
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Input
          error={!!props.error.email}
          helperText={props.error.email}
          size={"small"}
          variant={"outlined"}
          name={"email"}
          placeholder={t("CONTACT_EMAIL") + " *"}
          value={props.loggedInUserData.contact.email}
          onChange={(event) => {
            props.onChange(event);
            props.updateError("email");
          }}
        />
      </Grid>
      {/* <Grid item xs={6}>
        <Input
          error={!!props.error.name}
          helperText={props.error.name}
          name={"name"}
          size={"small"}
          variant={"outlined"}
          value={props.providerData.name}
          placeholder={t("PROVIDER_NAME") + "*"}
          onChange={(event) => {
            props.onChange(event);
            props.updateError("name");
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Input
          size={"small"}
          variant={"outlined"}
          name={"description"}
          value={props.providerData.description}
          onChange={(event) => props.onChange(event)}
          placeholder={t("PROVIDER_DESCRIPTION")}
        />
      </Grid>

      <Grid item xs={12}>
      <h3 className={"no-margin"}>{t("PROVIDER_CONTACT_DETAILS")}</h3>
      </Grid>
      <Grid item xs={6}>
        <Input
          error={!!props.error.contacts}
          helperText={props.error.contacts}
          size={"small"}
          variant={"outlined"}
          name={"name"}
          placeholder={t("CONTACT_NAME") + " *"}
          value={props.providerData.contacts[0].name}
          onChange={(event) => {
            props.onChangeContact(event);
            props.updateError("contacts");
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <InputPhone
          error={!!props.error.phone}
          helperText={props.error.phone}
          size={"small"}
          variant={"outlined"}
          placeholder={t("CONTACT_NUMBER")}
          name={"phone"}
          value={props.providerData.contacts[0].phone}
          onChange={(event) => {
            props.onChangeContact(event);
            props.updateError("phone");
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Input
          error={!!props.error.email}
          helperText={props.error.email}
          size={"small"}
          variant={"outlined"}
          name={"email"}
          placeholder={t("CONTACT_EMAIL") + " *"}
          value={props.providerData.contacts[0].email}
          onChange={(event) => {
            props.onChangeContact(event);
            props.updateError("email");
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Input
          error={!!props.error.attn}
          helperText={props.error.attn}
          size={"small"}
          variant={"outlined"}
          name={"attn"}
          placeholder={t("ATTENTION") + "*"}
          value={
            props.providerData.contacts[0].address
              ? props.providerData.contacts[0].address.attn
              : ""
          }
          onChange={(event) => {
            props.onChangeAddress(event);
            props.updateError("attn");
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Input
          error={!!props.error.addressLine1}
          helperText={props.error.addressLine1}
          size={"small"}
          variant={"outlined"}
          name={"addressLine1"}
          placeholder={t("STREET1") + " *"}
          value={
            props.providerData.contacts[0].address
              ? props.providerData.contacts[0].address.addressLine1
              : ""
          }
          onChange={(event) => {
            props.onChangeAddress(event);
            props.updateError("addressLine1");
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Input
          size={"small"}
          variant={"outlined"}
          name={"addressLine2"}
          placeholder={t("STREET2")}
          value={
            props.providerData.contacts[0].address
              ? props.providerData.contacts[0].address.addressLine2
              : ""
          }
          onChange={(event) => props.onChangeAddress(event)}
        />
      </Grid>
      <Grid item xs={6}>
        <Input
          error={!!props.error.city}
          helperText={props.error.city}
          size={"small"}
          variant={"outlined"}
          name={"city"}
          placeholder={t("CITY") + " *"}
          value={
            props.providerData.contacts[0].address
              ? props.providerData.contacts[0].address.city
              : ""
          }
          onChange={(event) => {
            props.onChangeAddress(event);
            props.updateError("city");
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Input
          error={!!props.error.zipCode}
          helperText={props.error.zipCode}
          size={"small"}
          variant={"outlined"}
          name={"zipCode"}
          placeholder={t("ZIP") + " *"}
          value={
            props.providerData.contacts[0].address
              ? props.providerData.contacts[0].address.zipCode
              : ""
          }
          onChange={(event) => {
            props.onChangeAddress(event);
            props.updateError("zipCode");
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <FormControl
          variant={"outlined"}
          className="custom-select-input"
          size={"small"}
          error={!!props.error.country}
        >
          <InputLabel id="country" htmlFor="country"> {t('SELECT_COUNTRY') + ' *'}</InputLabel>
          <Select
          // native
            label="select Country"
            value={
              props.providerData.contacts[0].address
                ? props.providerData.contacts[0].address.country
                : ""
            }
            inputProps={{
              name: "country",
              id: "country",
            }}
            onChange={(event) => {
              props.onChangeAddress(event);
              getStates(event.target.value);
              props.onChangeAddress({ target: { name: "state", value: "" } });
              props.updateError("country");
            }}
          >
            <option value="" disabled>
              {t("SELECT_COUNTRY") + " *"}
            </option>
            {props.countriesList.map((a) => (
              <option key={a.id} value={a.id}>
                {a.name}
              </option>
            ))}
          </Select>
          {props.error.country && (
            <span
              style={{
                color: "#f44336",
                marginLeft: "0px",
                fontSize: "0.75rem",
                marginTop: "4px",
              }}
            >
              {props.error.country}
            </span>
          )}
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl
          variant={"outlined"}
          className="custom-select-input"
          size={"small"}
          error={!!props.error.state}
        >
          <InputLabel id="state" htmlFor="state"> {t('SELECT_STATE') + ' *'}</InputLabel>
          <Select
            // native
            label="select State"
            onChange={(event) => {
              props.onChangeAddress(event);
              props.updateError("state");
            }}
            value={
              props.providerData.contacts[0].address
                ? props.providerData.contacts[0].address.state
                : ""
            }
            inputProps={{
              name: "state",
              id: "state",
            }}
          >
            <option value="" disabled>
              {t("SELECT_STATE") + " *"}
            </option>
            {statesList &&
              statesList.length > 0 &&
              statesList.map((a) => (
                <option key={a.id} value={a.id}>
                  {a.name}
                </option>
              ))}
          </Select>
          {props.error.state && (
            <span
              style={{
                color: "#f44336",
                marginLeft: "0px",
                fontSize: "0.75rem",
                marginTop: "4px",
              }}
            >
              {props.error.state}
            </span>
          )}
        </FormControl>
      </Grid> */}
      <Grid
        item
        align="right"
        size={{
          xs: 12,
        }}
      >
        <Button onClick={props.cancelData} style={{ marginRight: "10px" }}>
          {t("CANCEL")}
        </Button>
        {/* <Button onClick={props.submitData}>{t("UPDATE")}</Button> */}
        <Button onClick={props.submitProfileData}>{t("UPDATE")}</Button>
        <Loader loading={loading} />
      </Grid>
      {props.providerRole === "SOLUTION_PROVIDER" &&
        !props.securityGroupsList.includes("PARTNER_EMPLOYEE") && (
          <>
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <Divider style={{ marginBottom: "24px" }} />
              <h3 className={"no-margin"}>{t("THEME_INFO")}</h3>
            </Grid>

            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <Grid
                item
                style={{ marginBottom: "12px" }}
                size={{
                  xs: 12,
                }}
              >
                <Button
                  className={"buttonSecondary"}
                  onClick={uploadButtonClicked}
                >
                  <span
                    style={{ marginRight: ".25rem", verticalAlign: "middle" }}
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                  {t("UPLOAD_LOGO")}
                </Button>

                {/* <label htmlFor="logoUpload">{t("UPLOAD_LOGO")} : </label> */}
                <input
                  id="logoUpload"
                  type="file"
                  ref={hiddenFileInput}
                  onChange={handleImageUpload}
                />
              </Grid>
              <Grid
                item
                align="left"
                size={{
                  xs: 12,
                }}
              >
                {logoPreview && (
                  <img
                    src={`data:image/png;base64, ${logoPreview}`}
                    style={{
                      width: "fit-content",
                      maxHeight: "100px",
                      objectFit: "contain",
                    }}
                    alt="Logo"
                  />
                  // <img
                  //   src={logoPreview}
                  //   alt="Logo Preview"
                  //   style={{
                  //     width: "100%",
                  //     maxHeight: "150px",
                  //     objectFit: "contain",
                  //   }}
                  // />
                )}
              </Grid>
            </Grid>
            {/* Theme Color Selection Field */}
            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <label htmlFor="colorPicker">{t("SELECT_THEME_COLOR")} : </label>
              <input
                id="colorPicker"
                type="color"
                value={themeColor}
                onChange={(event) => {
                  const selectedColor = event.target.value;
                  setThemeColor(selectedColor);
                  props.setThemeColor(selectedColor);
                }}
              />
            </Grid>
            <Grid
              item
              align="right"
              size={{
                xs: 12,
              }}
            >
              <Button onClick={props.updateTheme}>{t("UPDATE")}</Button>
            </Grid>
          </>
        )}
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    tenantId: state.auth.tenantId,
    countriesList: state.global.countriesList,
    tenantData: state.auth.tenantData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(ContactDetails));
